import { useLayoutEffect, useState } from 'react';
import { debounce } from '@material-ui/core';

export default function useWindowSize() {
  const [size, setSize] = useState([0, 0]);

  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    const debouncedUpdatedSize = debounce(updateSize, 250);

    window.addEventListener('resize', debouncedUpdatedSize);
    updateSize();
    return () => window.removeEventListener('resize', debouncedUpdatedSize);
  }, []);

  return size;
}
